import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "overflow", "truncate", "paddingBlock", "paddingInline", "role"],
  _excluded2 = ["children", "columnName"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { Heading } from '../Typography';
import { useGridList } from './useGridList';
import { SortArrows } from './SortArrows';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { useTheme } from '../useTheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GridListHeaderItem = _ref => {
  let {
      children,
      overflow = 'hidden',
      truncate = true,
      paddingBlock = 'space-sm',
      paddingInline = 'space-md',
      role = 'cell'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isTrellisLight
  } = useTheme();
  const textTransform = isTrellisLight ? 'none' : 'uppercase';
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    overflow: overflow,
    paddingBlock: paddingBlock,
    paddingInline: paddingInline,
    role: role,
    children: /*#__PURE__*/_jsx(Heading, {
      fontSize: "xxxs",
      textTransform: textTransform,
      truncate: truncate,
      children: children
    })
  }));
};
const GridListHeaderItemSortableStyled = styled(GridListHeaderItem).withConfig({
  displayName: "GridListHeaderItem__GridListHeaderItemSortableStyled",
  componentId: "bitazy-0"
})(["", " cursor:pointer;user-select:none;", " &:hover{background:var(--selected-header-background);}&:focus{outline:none;", "}"], ({
  theme
}) => {
  const {
    isTrellisLight
  } = useTheme();
  const backgroundColor = isTrellisLight ? theme.color['specialty-table-header-hover'] : theme.color['fill-tertiary-hover'];
  return `--selected-header-background: ${backgroundColor};`;
}, ({
  isSorting
}) => isSorting && `
    background: var(--selected-header-background);
  `, ({
  theme
}) => `box-shadow: inset 0 0 0 1px ${theme.color['text-interactive-default']}`);
export const GridListHeaderItemSortable = _ref2 => {
  let {
      children,
      columnName
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    onSort,
    sortColumn,
    sortDirection
  } = useGridList();
  const isSorting = sortColumn === columnName;
  const handleSort = () => {
    onSort === null || onSort === void 0 || onSort({
      column: columnName,
      direction: isSorting ? sortDirection === 'ascending' ? 'descending' : 'ascending' : 'ascending'
    });
  };
  const handleKeyUp = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleSort();
    }
  };
  return /*#__PURE__*/_jsx(GridListHeaderItemSortableStyled, Object.assign({}, rest, {
    isSorting: isSorting,
    onClick: handleSort,
    onKeyUp: handleKeyUp,
    role: "button",
    tabIndex: 0,
    children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
      alignItems: "center",
      gap: "space-xs",
      children: [children, onSort && /*#__PURE__*/_jsx(SortArrows, {
        sortDirection: isSorting ? sortDirection : undefined
      })]
    })
  }));
};